import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const FadeUp = ({ children, delay = 0, className = "", y = 36 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const MaskedLines = ({
  lines,
  className = "",
  lineClassName = "",
  lastLineClassName = "",
  as: Tag = "span",
  delay = 0.15,
  stagger = 0.14,
}) => (
  <Tag className={className}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.1em] -mb-[0.1em]">
        <motion.span
          className={`block will-change-transform ${lineClassName} ${
            i === lines.length - 1 ? lastLineClassName : ""
          }`}
          initial={{ y: "115%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 1.1, delay: delay + i * stagger, ease: EASE }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </Tag>
);

export const GoldRule = ({ className = "" }) => (
  <motion.span
    aria-hidden="true"
    className={`block h-px bg-gold origin-left ${className}`}
    initial={{ scaleX: 0 }}
    whileInView={{ scaleX: 1 }}
    viewport={{ once: true }}
    transition={{ duration: 1.2, ease: EASE }}
  />
);

export const Overline = ({ children, className = "", as: Tag = "span", ...rest }) => (
  <Tag
    className={`inline-flex items-center gap-3 text-xs tracking-[0.28em] uppercase font-medium text-gold ${className}`}
    {...rest}
  >
    <span className="inline-block h-px w-8 bg-gold" aria-hidden="true" />
    {children}
  </Tag>
);
